import React from 'react';



type Props = {
  className?: string;
}
export const TypeOfProductsSheetsVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '32' height= '32' viewBox= '0 0 32 32' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'> 
      <path fill = 'currentColor' d = 'M7.2 21.162L5 22V9.028L18.2 4V6.507L7.2 10.697V21.162ZM24.8 13.006V21.641L16 24.993V16.358L24.8 13.006ZM27 10L13.8 15.028V28L27 22.972V10ZM11.6 13.697L22.6 9.507V7L9.4 12.028V25L11.6 24.162V13.697Z' />
    </svg>
  );
};





